import { useEffect } from "react";
import { CONTENT_GROUP_ACTION, userConstants } from "../constants";
import { useSelector } from "react-redux";

export const useMinimizeCardLoadHook = ({
    dispatch,
    content_group_id,
}) => {
    const { minimizedCards } = useSelector(state => state.minimized_card);
    const minimizedCard = minimizedCards?.find(card => card.id === content_group_id);
    const isMinimized = minimizedCard ? true : false;

    useEffect(() => {
        if (isMinimized) {
           const currentWorkSpace = minimizedCard.workspace;   
           const currentContentGroup = minimizedCard.content_group;
           const currentContent = null;

           dispatch({
               type: userConstants.CONTENT_SHOW,
               payload: {
                    data: {
                        workspace: currentWorkSpace,
                        content_group: currentContentGroup,
                        ...minimizedCard
                    }
               }
           })

           if (minimizedCard?.authorizations) {
                dispatch({
                    type: CONTENT_GROUP_ACTION.SET_AUTHORIZATIONS,
                    payload: {
                        data: {
                                authorizations: minimizedCard?.authorizations
                        }
                    }
                });
           }

           if (minimizedCard?.assigned_users){
                dispatch({
                    type: CONTENT_GROUP_ACTION.SET_ASSIGNED_USERS,
                    payload: {
                        data: {
                            assigned_users: minimizedCard?.assigned_users
                        }
                    }
                });
           }
        }
    }, [minimizedCard]);

    return { isMinimized };
}